<script setup lang="ts">
import JobMateLinkHeader from "../components/ui/JobMateLinkHeader.vue";
</script>

<template>
  <JobMateLinkHeader />
  <slot />
  <UNotifications />
</template>
